export const NAME = 'laminates';